import useSwitchLanguage from '@/hooks/useSwitchLanguage';
import { SUPPORTED_LANGUAGES } from '@/i18n';

export default function LanguageSwitcher({ className }) {
    const { lang, switchLanguage } = useSwitchLanguage();

    return (
        <ul className={`is-flex gap-3 list-reset ${className}`}>
            {SUPPORTED_LANGUAGES.map((code) => (
                <li key={code}>
                    <button
                        className={
                            'link-dn' +
                            (lang === code ? ' has-text-weight-semibold is-underlined' : '')
                        }
                        aria-current={lang === code ? true : undefined}
                        onClick={() => switchLanguage(code)}
                    >
                        {code.toUpperCase()}
                    </button>
                </li>
            ))}
        </ul>
    );
}
